import { SdkPersistConfig } from "@payping/redux";
import localForage from "localforage";

const storeVersion = 4;

const whitelist = ["auth", "user"];

const persistConfig: SdkPersistConfig = {
  storage: localForage,
  version: storeVersion,
  whitelist,
};

export default { ...persistConfig };
